"use client";
import { LogRequest, TServerErrorResponse } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const sendLog = async (data: LogRequest) => {
  const dataToSend = {
    ...data,
    data: {
      userAgent: `${navigator?.userAgent || ""}`,
      screen: `${window.screen.width}x${window.screen.height}`,
      ...(data.data || {}),
    },
  };

  if (process.env.NODE_ENV === "development") {
    console.log(dataToSend);
    return;
  }

  try {
    const response = await http.post(links.log.index, dataToSend);

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
